import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SidebarItem = ({ onClick, children, to, label, isMinified }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = to && location.pathname === to;

    const handleNavigate = (e) => {
        e.preventDefault();
        navigate(to);
    };

    return (
        <div
            onClick={onClick ? onClick : (to ? handleNavigate : undefined)}
            className={`group relative w-full px-4 py-3 flex items-center gap-4 cursor-pointer transition-all duration-300 ease-in-out
                ${isActive 
                    ? 'bg-white/10 text-white' 
                    : 'text-white/80 hover:bg-white/5'
                }
                ${isMinified ? 'justify-center' : 'justify-start'}
            `}
            role={onClick ? 'button' : 'link'}
            aria-label={label}
        >
            <div className={`flex-shrink-0 transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-105'}`}>
                {children}
            </div>
            
            {!isMinified && (
                <span className='font-medium text-sm whitespace-nowrap transition-opacity duration-300'>
                    {label}
                </span>
            )}

            {/* Label flottant pour le mode minifié */}
            {isMinified && (
                <div className="absolute left-[calc(100%+1rem)] top-1/2 -translate-y-1/2 opacity-0 pointer-events-none
                    group-hover:opacity-100 transition-all duration-200 z-50 min-w-[120px]">
                    <div className="bg-primary text-white text-sm py-2 px-3 rounded-md shadow-lg whitespace-nowrap
                        before:content-[''] before:absolute before:left-[-0.5rem] before:top-1/2 before:-translate-y-1/2
                        before:border-[6px] before:border-transparent before:border-r-primary">
                        {label}
                    </div>
                </div>
            )}
            
            {isActive && (
                <div className="absolute left-0 top-0 w-1 h-full bg-white rounded-r-md" />
            )}
        </div>
    );
};

export default SidebarItem;
